import React, { Component } from "react";

import "react-datepicker/dist/react-datepicker.css";
import API from "../../apiService.js";
import ALERT from "../component/Alert";

export class Subjektif extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anamnese: props.patient.anamneses[0]
        ? props.patient.anamneses[0].anamnese
        : "",
      eval: props.patient.anamneses[0] ? props.patient.anamneses[0].eval : "",
      id: props.patient.anamneses[0] ? props.patient.anamneses[0].id : "",
      nursing_anamnese: props.patient.anamneses[0]
        ? props.patient.anamneses[0].nursing_anamnese
        : "",
      pregnant_status: props.patient.anamneses[0]
        ? props.patient.anamneses[0].pregnant_status
        : "-",
      treat: props.patient.anamneses[0] ? props.patient.anamneses[0].treat : "",
      visit_id: props.patient.anamneses[0]
        ? props.patient.anamneses[0].visit_id
        : props.patient.id,
      visit_inpatient_detail_id: props.patient.anamneses[0]
        ? props.patient.anamneses[0].visit_inpatient_detail_id
        : "0",
    };
  }

  handleTextChange = (e) => {
    let anamneses = [];
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        anamneses = { data: [this.state], param: "anamneses" };
        this.props.parentCallback(anamneses);
      }
    );
  };

  checkPendaftaranBpjs = async () => {
    if (
      this.props.patient.payments?.bpjs_status == 1 &&
      this.props.patient.pcare_queue_number == null
    ) {
      const bridgingResult = await API.post(
        `/pcare/pendaftaran/${this.props.patient.id}`
      );
    }
  };

  handleSubmit = (e) => {
    // this.checkPendaftaranBpjs();
    if (this.state.id > 0) {
      this.PutData();
    } else {
      this.PostData();
    }
    this.props.nextTab();
  };
  PostData = async () => {
    var param = this.state;
    let res = await API.post(`management/anamneses/create`, param);
    // console.log(res);
    if (res.code === 200) {
      ALERT("success", "Berhasil Menyimpan Data ");
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };

  PutData = async () => {
    var param = this.state;
    let res = await API.put(`management/anamneses/update`, param);
    if (res.code === 200) {
      ALERT("success", "Berhasil Menyimpan Data ");
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };
  onReload = () => {
    this.props.history.push("/pelayanan");
  };

  componentDidMount() {
    this.props.getData();
    console.log(this.props);
  }

  render() {
    // console.log(this.props.patient);
    return (
      <>
        <div className="form-group row">
          <label
            htmlFor="example-text-input"
            className="col-md-5 col-form-label col-form-label-sm"
          >
            Cek Status Hamil Pasien
          </label>
          <div className="col-md-7">
            <div className="row">
              <select
                className="form-control form-control-sm col-md-6"
                name="pregnant_status"
                onChange={this.handleTextChange}
                value={this.state?.pregnant_status}
              >
                <option value="-">Tidak</option>
                <option value="Hamil">Hamil</option>
                <option value="K1">K1</option>
                <option value="K2">K2</option>
                <option value="K3">K3</option>
                <option value="K4">K4</option>
                <option value="K5">K5</option>
                <option value="K6">K6</option>
              </select>
            </div>
          </div>
          <label
            htmlFor="example-text-input"
            className="col-md-5 col-form-label col-form-label-sm"
          >
            Anamnese Keperawatan
          </label>
          <div className="col-md-7">
            <div className="row">
              <textarea
                className="form-control form-control-sm"
                type="text"
                placeholder="Keluhan Pasien"
                name="nursing_anamnese"
                onChange={this.handleTextChange}
                value={this.state.nursing_anamnese}
              />
            </div>
          </div>
        </div>

        <button className="btn btn-primary" onClick={this.handleSubmit}>
          Simpan
        </button>
        <button className="btn btn-danger" onClick={this.onReload}>
          Tutup
        </button>
      </>
    );
  }
}

export default Subjektif;
